<svg width="711" height="711" viewBox="0 0 711 711" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M498.055 384.315H403.087V464.744H498.055C526.072 464.744 542.688 449.697 542.688 424.795C542.688 403.008 527.133 384.315 498.055 384.315Z" fill="url(#paint0_linear_min)"/>
<path d="M535.964 283.642C535.964 261.856 520.387 245.77 495.485 245.77H403.124V321.006H495.485C520.387 321.006 535.964 305.429 535.964 283.642Z" fill="url(#paint1_linear_min)"/>
<path d="M355.5 0C159.156 0 0 159.156 0 355.5C0 551.844 159.156 711 355.5 711C551.844 711 711 551.844 711 355.5C711 159.156 551.844 0 355.5 0ZM517.264 528.577H329.405L93.0456 182.445H511.563C577.475 182.445 611.193 224.472 611.193 270.652C611.193 314.247 584.214 343.303 551.512 350.042C588.368 355.743 617.932 391.56 617.932 435.156C617.932 487.059 583.176 528.577 517.264 528.577Z" fill="url(#paint2_linear)"/>
<defs>
<linearGradient id="paint0_linear_min" x1="472.894" y1="0.00762019" x2="472.894" y2="711.027" gradientUnits="userSpaceOnUse">
<stop stop-color="#C4262D"/>
<stop offset="0.2428" stop-color="#C0242B"/>
<stop offset="0.4885" stop-color="#B41D25"/>
<stop offset="0.7357" stop-color="#A0111B"/>
<stop offset="0.9825" stop-color="#83010D"/>
<stop offset="1" stop-color="#81000C"/>
</linearGradient>
<linearGradient id="paint1_linear_min" x1="469.535" y1="0.00468886" x2="469.535" y2="711.022" gradientUnits="userSpaceOnUse">
<stop stop-color="#C4262D"/>
<stop offset="0.2428" stop-color="#C0242B"/>
<stop offset="0.4885" stop-color="#B41D25"/>
<stop offset="0.7357" stop-color="#A0111B"/>
<stop offset="0.9825" stop-color="#83010D"/>
<stop offset="1" stop-color="#81000C"/>
</linearGradient>
<linearGradient id="paint2_linear" x1="355.495" y1="0.00662875" x2="355.495" y2="711.024" gradientUnits="userSpaceOnUse">
<stop stop-color="#C4262D"/>
<stop offset="0.2428" stop-color="#C0242B"/>
<stop offset="0.4885" stop-color="#B41D25"/>
<stop offset="0.7357" stop-color="#A0111B"/>
<stop offset="0.9825" stop-color="#83010D"/>
<stop offset="1" stop-color="#81000C"/>
</linearGradient>
</defs>
</svg>
